module.exports = __webpack_public_path__ + "static/media/Hospitality_35.34be1210.jpg";